<template>
  <el-container direction='vertical' class="exchange-list">
    <div class="nut-tab-title">
      <span
        @click="tabSwitch(1)"
        :class="current === 1 ? 'nut-tab-active' :''"
        class="nut-title-nav-list "
      >
        <a
          href="javascript:void(0)"
          class="nut-tab-link"
        >未核销</a></span>
      <span
        @click="tabSwitch(2)"
        :class="current === 2 ? 'nut-tab-active' :''"
        class="nut-title-nav-list "
      >
        <a
          href="javascript:void(0)"
          class="nut-tab-link"
        >已核销</a>
      </span>
    </div>
    <div v-if="current===2" class="v-nut-infiniteloading">
      <div class="stamp" v-for="(item,i) in listData" :key='i'>
        <div class="par">
          <div class="stamp-top">{{item.coupon_name}} </div>
          <div class="stamp-cdkey">核销码<span> {{item.cdkey}}</span>
            <div
              class="stamp-btn"
              @click="item.show = !item.show"
            ><span>详情</span>
              <i
                v-if="!item.show"
                class="el-icon-arrow-down"
              ></i>
              <i
                v-if="item.show"
                class="el-icon-arrow-up"
              ></i>
            </div>
          </div>
          <div class="stamp-bom01">{{item.goods_title}}</div>
        </div>
        <div v-if="item.show" class="stamp-description">
          <p>使用积分：{{item.costpoints}}</p>
          <p>兑换时间：{{item.createtime}}</p>
          <p>有效期：{{item.starttime === item.endtime ? '永久有效' : `${item.starttime} - ${item.endtime}`}}</p>
          <p v-if="item.goods_description" >兑换须知：{{item.goods_description}}</p>
        </div>
      </div>
      <p v-if="listData.length === 0" class="no-data">暂无数据</p>
      <p v-if="isHasMore" @click="onInfinite" class="v-more"><nut-icon type="down" color="#848484"></nut-icon></p>
    </div>
    <div v-if="current===1" class="v-nut-infiniteloading">
      <div class="stamp" v-for="(item,i) in listDataUnless" :key='i'>
        <div class="par" :class="isOverdue(item)?'overdue':''">
          <div class="stamp-top">{{item.coupon_name}} </div>
          <div class="stamp-cdkey">核销码<span> {{item.cdkey}}</span>
            <div
              class="stamp-btn"
              @click="item.show = !item.show"
            ><span>详情</span>
              <i
                v-if="!item.show"
                class="el-icon-arrow-down"
              ></i>
              <i
                v-if="item.show"
                class="el-icon-arrow-up"
              ></i>
            </div>
          </div>
          <div class="stamp-bom01">{{item.goods_title}}</div>
        </div>
        <div v-if="item.show" class="stamp-description">
          <p>使用积分：{{item.costpoints}}</p>
          <p>兑换时间：{{item.createtime}}</p>
          <p>有效期：{{item.starttime === item.endtime ? '永久有效' : `${item.starttime} - ${item.endtime}`}}</p>
          <p v-if="item.goods_description" >兑换须知：{{item.goods_description}}</p>
        </div>
      </div>
      <p v-if="listDataUnless.length === 0" class="no-data">暂无数据</p>
      <p v-if="isHasMoreUnless" @click="onInfiniteUnless" class="v-more"><nut-icon type="down" color="#848484"></nut-icon></p>
    </div>
  </el-container>
</template>
<script>
import dayjs from 'dayjs'
import { exchangeListApi } from '@/views/mobile/GoodsList/apis'
export default {
  data () {
    return {
      listData: [],
      page: 1,
      size: 10000,
      pageAll: 0,
      isHasMore: false,
      listDataUnless: [],
      pageUnless: 1,
      sizeUnless: 10000,
      pageAllUnless: 0,
      isHasMoreUnless: false,
      current: 1
    }
  },
  computed: {
    isOverdue () {
      return (item) => {
        let date = dayjs(new Date()).valueOf()
        let endtime = dayjs(item.endtime).valueOf()
        if (item.starttime === item.endtime) {
          return false
        } else {
          return date > endtime
        }
      }
    }
  },
  methods: {
    tabSwitch (index) {
      this.current = index
    },
    // 已核销
    onInfinite () {
      this.page = this.page + 1
      this.requestList()
    },
    // 未核销
    onInfiniteUnless () {
      this.pageUnless = this.pageUnless + 1
      this.requestListUnless()
    },
    // 已核销
    requestList () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.page)
      data.append('size', this.size)
      data.append('status', '1')
      exchangeListApi(data)
        .then((result) => {
          this.loading.hide()
          if (result) {
            let resultList = result.data.list
            resultList.forEach((element) => {
              element.show = false
            })
            this.listData = this.listData.concat(resultList)
            this.pageAll = result.data.pager.pages
            if (this.page < this.pageAll) {
              this.isHasMore = true
            } else {
              this.isHasMore = false
            }
          }
        })
        .catch((error) => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    // 未核销
    requestListUnless () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.pageUnless)
      data.append('size', this.sizeUnless)
      data.append('status', '0')
      exchangeListApi(data)
        .then((result) => {
          this.loading.hide()
          if (result) {
            let resultList = result.data.list
            resultList.forEach((element) => {
              element.show = false
            })
            this.listDataUnless =
              this.listDataUnless.concat(resultList)
            this.pageAllUnless = result.data.pager.pages
            if (this.pageUnless < this.pageAllUnless) {
              this.isHasMoreUnless = true
            } else {
              this.isHasMoreUnless = false
            }
          }
        })
        .catch((error) => {
          if (error) {
            this.loading.hide()
          }
        })
    }
  },
  mounted () {
    this.requestList()
    this.requestListUnless()
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
    let shop = window.location.hostname.split('.')[0]
    if (shop === 'szty') {
      document.title = '陶源酒家'
    } else if (userInfo.ext.shopname !== '') {
      document.title = userInfo.ext.shopname
    } else {
      document.title = '香港富临皇宫'
    }
  }
}
</script>
<style lang="less">
.exchange-list{
  .v-nut-infiniteloading {
    padding: 8px;
  }
  .v-tip {
    position: absolute;
    top: 36%;
    color: #848484;
    width: 100%;
    text-align: center;
    left: 0;
  }
  .v-more{
    text-align: center;
    cursor: pointer;
  }
  .stamp {
    margin-bottom: 16px;
    position: relative;
    cursor: pointer;
    width: 100%;
    overflow: hidden;
    background: #fcffba;
    .par {
      width: 100%;
      background: #e82a36;
      color: #fcffba;
      box-sizing: border-box;
      padding: 12px;
      position: relative;
      &.overdue{
        background: #848484;
        color: #000;
      }
      .stamp-btn {
        font-size: 12px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .stamp-top {
        font-size: 18px;
        font-weight: 600;
      }
      .stamp-cdkey {
        margin-top: 4px;
        font-size: 18px;
        position: relative;
      }
      .stamp-bom01 {
        margin-top: 12px;
        font-size: 15px;
        color: #f1f1f1;
      }
      .stamp-bom02 {
        margin-top: 4px;
        font-size: 13px;
      }
    }
    .stamp-copy {
      height: 106px;
      width: 60px;
      position: absolute;
      right: 0;
      top: 23px;
      color: #e82a36;
      font-size: 22px;
      text-align: center;
    }
    .stamp-description {
      background: #eee;
      font-size: 12px;
      padding: 8px;
    }
  }
}
.no-data{
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/GoodsList/exchangeList.vue